module.exports = __webpack_public_path__ + "static/media/bg-home.187075d7.jpg";